import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import iconPath from '../../../assets/images/authentication/verifyCustomerSuccess.svg';
import { DialogLayout } from '../../../components/Authentication/components/DialogLayout/index.js';
import { useAuthentication } from '../../../hooks/index.js';
import { Button } from '../../../primitives/index.js';
export const VerifyCustomerSuccess = () => {
  const {
    t
  } = useTranslation('authentication');
  const {
    toggleDialog
  } = useAuthentication();
  return _jsx(DialogLayout, {
    dialog: "verifyCustomer",
    onClose: () => toggleDialog('verifyCustomer'),
    icon: iconPath,
    title: t('dialogs.verifyCustomerSuccess.title'),
    subtitle: t('dialogs.verifyCustomerSuccess.subtitle'),
    controllers: _jsx(Button, {
      onClick: () => toggleDialog('verifyCustomer'),
      fullWidth: true,
      children: t('dialogs.verifyCustomerSuccess.buttonText')
    })
  });
};